import React, {Component, Fragment} from 'react';
import {Button, Input} from 'reactstrap';
import ReactTable from 'react-table';
import UserForm from './UserForm.js';

const ROLLER_PREFIX = process.env.REACT_APP_ROLLER_PREFIX;
const SESSION_KEY = process.env.REACT_APP_SESSION_KEY;
const API_PREFIX = process.env.REACT_APP_API_PREFIX;

const USER_TEMPLATE = {
	user: {
		email:         '',
		id:            0,
		has_2fa:       false,
		has_2fa_setup: false
	},

	permission_group: {
		id:   0,
		name: ''
	},

	properties: []
};

const USER_ADMIN_COLUMNS = [
	{
		Header:   'Edit',
		accessor: 'edit',
		width:    65
	},
	{
		Header:   'Reset',
		accessor: 'reset',
		width:    150
	},
	{
		Header:   'Email',
		accessor: 'user.email',
		width:    200
	},
	{
		Header:   '2fA Enabled',
		accessor: 'user.has_2fa',
		width:    100
	},
	{
		Header:   '2fA Setup Complete',
		accessor: 'user.has_2fa_setup',
		width:    100
	},
	{
		Header:   'Permission Group',
		accessor: 'display.permission_group',
		width:    100
	},
	{
		Header:   'Properties',
		accessor: 'display.property_number_list'
	}
];

// LO AND BEHOLD! THE POWER OF WISHFUL THINKING:
// -- CREATE --
// ! 0) Add a form to the UserAdmin page that allows creation of a user once the following has been specified:
// Email, Has2FA, Properties, PermissionGroup
// ! 1) Utilize "protected" dropdown to ensure only real properties are assigned.
// 2) Add method to POST this data back.
// -- UPDATE --
// ! 0) Add button and method populate CreateForm with existing user data.
// ! 1) Record alterations to data in user.metadata
// 2) Add method to POST this data back.

/*
A user record looks like:
{
   email: 'an@e.mail',
   has_2fa: false,
   has_2fa_setup: false,
   permission_group: {...},
   properties: [
		{
			id: 0,
			inital: true, // Came in on the GET
			persisted: true, // Should be saved. (Is false if deleted)
			value: 31237
		} ...
   ],

   display: {
	   username: "a_name",
	   properties: "31237, ...",
	   permission_group: "permission_name"
   }
}
*/

class UserAdmin extends Component {
	constructor(props) {
		super(props);

		this.state = {
			displayUserList:     [],
			emailList: 			       [],
			formRecord:          {},
			loading:             false,
			status:              '',
			permissionGroupList: [],
			propertyFilter:      [],
			propertyList:        [],
			propertyReady:       false,
			showForm:            false
		};

		this.clearAll = this.clearAll.bind(this);

		this.renderEditButton = this.renderEditButton.bind(this);
		this.renderResetPasswordButton = this.renderResetPasswordButton.bind(this);
		this.render2FAEnabled = this.render2FAEnabled.bind(this);
		this.render2FASetup = this.render2FASetup.bind(this);

		this.toggleModal = this.toggleModal.bind(this);
		this.toggleLoader = this.toggleLoader.bind(this);
	}

	componentDidMount() {
		this.fetchData();
	}

	toggleLoader() {
		let loader = this.state.loading;
		this.setState({loading: !loader});
	}

	renderEditButton(cellInfo) {
		let btn = (
			<Button color="success" onClick={() => {
				return this.setState({formRecord: this.state.displayUserList[cellInfo.index], showForm: true});
			}}>Edit</Button>
		);

		return btn;
	}

	renderResetPasswordButton(cellInfo) {
		let target = this.state.displayUserList[cellInfo.index];
		if (!target || !target.user || !target.user.email) {
			return 'Could not find user email';
		}

		let btn = (
			<Button color="info" onClick={() => {
				console.log(target.user.email);
				return this.props.forgotPasswordRequest(target.user.email);
			}}>Reset Password</Button>
		);
		return btn;
	}

	fetchData() {
		this.toggleLoader();
		/* let userURL = `${ROLLER_PREFIX}/?session_key=${SESSION_KEY}`; */
		let qps = this.props.md5GetQueryParams();
		let propertyURL = `${API_PREFIX}/bronco/legacy/allPropNums/?${qps}`;

		fetch(propertyURL)
			.then((res) => {
				if (!res.ok) {
					return false;
				}
				return res.json();
			})
			.then((propertyRes) => {
				if (!propertyRes || !propertyRes.data) {
					return this.setState({userMsg: 'Failed to load propertyRes'}, this.toggleLoader);
				}

				let {data} = propertyRes;

				let status = '';
				if (!this.state.propertyReady) {
					status = '... Have Properties, need Users';
				}

				this.setState({
					propertyList:  data,
					propertyReady: true,
					status:        status
				},
				this.toggleLoader);
			});
	}

	isReady() {
		return this.state.propertyReady;
	}

	changePropertyFilter(value) {
		this.setState({propertyFilter: value});
	}

	applyPropertyFilter() {
		let filter = this.state.propertyFilter;
		if (filter === '') {
			window.alert('Must provide at least 1 number to search by property.');
			return this.setState({displayUserList: []});
		}

		return this.applyFilter('property_number', filter);
	}

	applyFilter(filterKey, filter) {
		this.toggleLoader();
		let searchObj = {};
		searchObj[filterKey] = filter;

		let searchBody = JSON.stringify(searchObj);
		let searchURL = `${ROLLER_PREFIX}/search/`;

		fetch(searchURL, {
			method:  'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: searchBody
		}).then((res) => {
			if (!res.ok) {
				console.error(`Bad response for Search-by-${filterKey}:`);
				console.log(res);
				return false;
			}

			return res.json();
		}).then((maybeJSON) => {
			console.log(maybeJSON);
			if (!maybeJSON || !maybeJSON.data) {
				this.toggleLoader();
				return;
			}

			if (maybeJSON.data.email_list) {
				return this.handleEmailSearch(maybeJSON.data.email_list);
			}

			if (maybeJSON.data.permission_group_list) {
				this.setState({permissionGroupList: maybeJSON.data.permission_group_list});
			}

			if (!maybeJSON.data.record_list || maybeJSON.data.record_list.length <= 0) {
				this.toggleLoader();
				window.alert('Found no results.');
				return;
			}

			let nextDisplay = maybeJSON.data.record_list;
			let finalDisplay = [];
			nextDisplay.forEach((record) => {
				record.display = {};
				let displayPropertyList = [];

				record.display.property_number_list = '';
				if (record.property_number_list) {
					record.property_number_list.forEach((propNum) => {
						if (propNum.record.property_number) {
							displayPropertyList.push(propNum.record.property_number);
						}
					});

					record.display.property_number_list = displayPropertyList.join(', ');
				}

				record.display.permission_group = 'none';
				if (record.permission_group.name) {
					record.display.permission_group = record.permission_group.name;
				}

				finalDisplay.push(record);
			});

			this.setState({displayUserList: finalDisplay}, this.toggleLoader);
			console.log(finalDisplay);
		});
	}

	handleEmailSearch(emailList) {
		if (emailList.length <= 0) {
			this.toggleLoader();
			window.alert('Found no results.');
			return;
		}

		this.setState({emailList: emailList}, this.toggleLoader);
	}

	changeEmailFilter(value) {
		this.setState({emailFilter: value});
	}

	applyEmailFilter() {
		let filter = this.state.emailFilter;
		if (filter === '') {
			window.alert('Must have atleast 1 character to search by email');
			return this.setState({displayUserList: []});
		}

		return this.applyFilter('email', filter);
	}

	clearUsers() {
		this.setState({displayUserList: [], emailList: []});
	}

	clearAll() {
		this.changePropertyFilter('');
		this.changeEmailFilter('');
		this.clearUsers();
	}

	makeFilters() {
		if (!this.isReady()) {
			return '';
		}

		return (
			<Fragment>
				<div className="dualSearchFields">
					<Button className="ml-2" onClick={() => {
						this.clearAll();
					}}>Reset Data</Button>
				</div>

				<div className="dualSearchFields">
					<p>Search Property Number</p>
					<input
						type="number"
						value={this.state.propertyFilter}
						onChange={(e) => {
							return this.changePropertyFilter(e.target.value);
						}}
					/>

					<Button className="ml-2" onClick={() => {
						this.clearUsers();
						this.applyPropertyFilter();
						this.changePropertyFilter('');
					}}>Search</Button>
				</div>

				<div className="dualSearchFields">
					<p>Search Email</p>
					<input
						type="text"
						value={this.state.emailFilter}
						onChange={(e) => {
							return this.changeEmailFilter(e.target.value);
						}}
					/>

					<Button className="ml-2" onClick={() => {
						this.clearUsers();
						this.applyEmailFilter();
						this.changeEmailFilter('');
					}}>Search</Button>
				</div>


				<div className="dualSearchFields">
					<Button onClick={() => {
						this.setState({formRecord: USER_TEMPLATE, showForm: true});
					}}>
						Create New User
					</Button>
				</div>

			</Fragment>
		);
	}

	makeModal() {
		if (!this.isReady() || !this.state.showForm) {
			return '';
		}

		return (
			<UserForm
				record={this.state.formRecord}
				toggleModal={this.toggleModal}
				toggleLoader={this.toggleLoader}
				clearAll={this.clearAll}
				allProperties={this.state.propertyList}
				allPermissionGroups={this.state.permissionGroupList}
			/>
		);
	}

	toggleModal() {
		let next = !this.state.showForm;
		this.setState({showForm: next});
	}

	render2FABool(cellInfo, key) {
		let target = this.state.displayUserList[cellInfo.index].user;
		let value = 'false';
		if (target[key]) {
			value = 'true';
		}

		return <span>{value}</span>;
	}

	render2FAEnabled(cellInfo) {
		return this.render2FABool(cellInfo, 'has_2fa');
	}

	render2FASetup(cellInfo) {
		return this.render2FABool(cellInfo, 'has_2fa_setup');
	}

	makeTable() {
		if (!this.isReady()) {
			return '';
		}

		if (this.state.emailList.length > 0) {
			return this.makeEmailList();
		}

		if (this.state.displayUserList.length <= 0) {
			return '';
		}

		let nextColumns = USER_ADMIN_COLUMNS.map((col) => {
			if (col.Header === '2fA Enabled') {
				col.Cell = this.render2FAEnabled;
				return col;
			}

			if (col.Header === '2fA Setup Complete') {
				col.Cell = this.render2FASetup;
				return col;
			}

			if (col.Header === 'Reset') {
				col.Cell = this.renderResetPasswordButton;
				return col;
			}

			if (col.Header !== 'Edit') {
				return col;
			}

			col.Cell = this.renderEditButton;
			return col;
		});

		return (
			<ReactTable
				data={this.state.displayUserList}
				columns={nextColumns}
				defaultPageSize={10}
				defaultSorted={[
					{
						id:   'ID',
						desc: true
					}
				]}
			/>
		);
	}

	makeEmailList() {
		return this.state.emailList.map((user, i) => {
			return (
				<div key={`email-${i}`}>
					<p>{user.email} -- <Button
						color="success"
						onClick={() => {
							this.setState({emailFilter: user.email}, () => {
								this.clearUsers();
								this.applyEmailFilter();
								this.changeEmailFilter('');
							});
						}}
					>Search for {user.email}</Button></p>
				</div>
			);
		});
	}

	render() {
		let filters = this.makeFilters();
		let modal = this.makeModal();
		let table = this.makeTable();
		let loader = '';

		if (!this.isReady() || this.state.loading) {
			loader = <h1>LOADING</h1>;
		}

		return (
			<Fragment>
				{loader}
				{filters}
				{table}
				{modal}
			</Fragment>
		);
	}
}

export default UserAdmin;



// WEBPACK FOOTER //
// ./src/components/UserAdmin.js